import Header from "../components/Header.jsx";
import Hero from "../components/Hero.jsx";
import HomePageCard from "../components/HomePageCard.jsx";
import IdeaIcon from "../assets/IdeaIcon.jsx";
import BrainIcon from "../assets/BrainIcon.jsx";
import ProfitIcon from "../assets/ProfitIcon.jsx";
import PortFolio from "../components/PortFolio.jsx";
import DashboardOnHomePage from "../components/DashboardOnHomePage.jsx";
import Features from "../components/Features.jsx";
import Questions from "../components/Questions.jsx";
import Footer from "../components/Footer.jsx";
import Rating from "../components/Rating";
import WhatsAppSupportLink from "../components/WhatsAppSupportLink";
import SmartsupChat from "../components/SmartsupChat.jsx"; 
import {Button} from "@nextui-org/react"; 
import {useNavigate} from "react-router-dom"; 
import News from '../components/News'; 
import CryptoTicker from "../components/CryptoTicker"; 
import Swal from 'sweetalert2';
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import InvestmentPlan from "../components/InvestmentPlan.jsx";
import HowToGetStarted from "../components/HowToGetStarted"; 


const choices = [
  {
    id: 1,
    icon: IdeaIcon,
    textBody: `Your money will be more useful and profitable in the long run.
		Through investing, you manage your money and can increase the value of the money you have`,
    title: "Increase value for money ",
  },
  {
    id: 2,
    icon: ProfitIcon,
    textBody:
      "Financial freedom is a condition in which you are financially independent. It means that your income is sufficient to meet your daily needs.",
    title: "Achieving financial freedom",
  },
  {
    id: 3,
    icon: BrainIcon,
    textBody:
      "Your insight into the economy and finance will be wider. It is possible you will become a reliable financial planner.",
    title: "Open the knowledge",
  },
];

// Component for Years of Experience with Animation
const YearsOfExperience = () => (
  <div className="text-center my-[4rem]">
    <motion.h2
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      className="text-3xl md:text-4xl font-bold"
    >
      Over <p className="text-blue-500">5 years</p> of investment experience
    </motion.h2>
    <motion.p
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5 }}
      className="text-lg md:text-xl mt-2"
    >
      Guiding you on your journey to financial freedom
    </motion.p>
  </div>
);

// Component for Modernized Crypto Prices Ticker
// Component for Modernized Crypto Prices Ticker
// Component for Top Stories from TradingView
// Component for How to Get Started Section
const withdrawalMessages = [
  "🚨 Alert: A withdrawal of $500 was made from New York, USA!",
  "💰 Notification: $300 has been withdrawn from London, UK.",
  "🌍 Heads up: A user in Tokyo, Japan just withdrew $700.",
  "⚠️ Attention: $450 has been taken out from Sydney, Australia.",
  "💸 Notice: A withdrawal of $200 occurred in Berlin, Germany.",
  "🔔 Alert: $1,200 withdrawn from Toronto, Canada!",
  "💵 Update: A user in Paris, France withdrew $600.",
  "📉 Warning: $400 has been withdrawn from Madrid, Spain.",
  "🏦 Notification: $800 taken out from Singapore.",
  "🚀 Heads up: A $1,000 withdrawal from Dubai, UAE.",
  "💳 Alert: A user in Mumbai, India just withdrew $250.",
  "🌐 Update: $750 has been withdrawn from Johannesburg, South Africa.",
  "📈 Notice: $300 withdrawn from Seoul, South Korea.",
  "🛑 Alert: $900 taken out from Sao Paulo, Brazil.",
  "🏙️ Notification: A user in Mexico City withdrew $350.",
  "📊 Heads up: $650 has been withdrawn from Rome, Italy.",
  "🤑 Attention: A withdrawal of $2,000 from Bangkok, Thailand!",
  "💸 Update: $850 taken out from Istanbul, Turkey.",
  "🎉 Alert: $1,500 withdrawn from Amsterdam, Netherlands.",
  "📣 Notification: $400 has been taken out from Vienna, Austria.",
  "🗺️ Notice: A user in Warsaw, Poland withdrew $600.",
  "🚨 Update: $550 withdrawn from Cairo, Egypt.",
  "💵 Alert: A user in Jakarta, Indonesia just withdrew $300.",
  "🌍 Notification: $2,300 has been withdrawn from Lagos, Nigeria.",
  "💰 Heads up: $1,100 taken out from Zurich, Switzerland.",
  "📈 Attention: A withdrawal of $950 from Nairobi, Kenya.",
  "🧳 Update: $700 withdrawn from Lisbon, Portugal.",
  "📊 Alert: $450 taken out from Athens, Greece.",
  "🏦 Notification: A user in Dubai, UAE withdrew $1,200.",
  "🌐 Notice: $800 has been withdrawn from Helsinki, Finland.",
  "🚀 Heads up: $300 taken out from Oslo, Norway.",
  "🔔 Alert: A withdrawal of $600 from Prague, Czech Republic.",
  "📉 Notification: $500 withdrawn from Budapest, Hungary.",
  "💳 Attention: $700 has been taken out from Tel Aviv, Israel.",
  "🏙️ Update: $400 withdrawn from Dublin, Ireland.",
  "💸 Notice: A user in Caracas, Venezuela just withdrew $1,000.",
  "📣 Heads up: $200 has been withdrawn from Manila, Philippines.",
  "🤑 Alert: A withdrawal of $300 from Taipei, Taiwan.",
  "📊 Notification: $1,800 taken out from Santiago, Chile.",
  "🔔 Update: $950 withdrawn from Boston, USA.",
  "🌍 Attention: A user in San Francisco withdrew $1,500.",
  "🏦 Notice: $650 has been withdrawn from Seattle, USA.",
  "💰 Heads up: $400 taken out from Austin, USA.",
  "📈 Alert: $2,200 withdrawn from Miami, USA.",
  "🛑 Notification: $1,200 taken out from Washington, D.C.",
  "💳 Update: A user in Los Angeles withdrew $350.",
  "🌐 Notice: $600 has been withdrawn from Vancouver, Canada.",
  "🚀 Heads up: $800 taken out from Montreal, Canada.",
  "🔔 Alert: A withdrawal of $1,100 from Atlanta, USA.",
  "📉 Notification: $1,000 has been withdrawn from Orlando, USA.",
  "💵 Attention: A user in Philadelphia withdrew $400.",
  "🏦 Update: $700 taken out from Denver, USA.",
  "🤑 Notice: $900 withdrawn from Baltimore, USA."
];
const getRandomMessage = () => {
  const randomIndex = Math.floor(Math.random() * withdrawalMessages.length);
  return withdrawalMessages[randomIndex];
};
// HomePage Component

const HomPage = () => {
 useEffect(() => {
    const showWithdrawalAlert = () => {
      Swal.fire({
        title: 'Withdrawal Alert!',
        text: getRandomMessage(),
        icon: 'info',
        showCloseButton: false,
        showCancelButton: false,
        timer: 5000, // Auto-dismiss after 5 seconds
        timerProgressBar: true,
        customClass: {
          popup: 'bg-gray-800 text-white rounded-lg shadow-lg',
          title: 'text-xl font-semibold',
          htmlContainer: 'text-lg',
          closeButton: 'hidden', // Hide the close button
        },
      });
    };
    const intervalId = setInterval(showWithdrawalAlert, 45000); 
    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);
     return (
    <div>
      <Header />
      <Hero />
      <div className="flex flex-col items-center justify-center mt-[5%]">
        <div className="flex justify-center">
          <div className="bg-black w-[90vw] h-[25rem]">
            <p className="text-white text-center align-center p-[0.8rem] text-2xl md:text-3xl mt-[2rem]">
              Get started on your profitable journey
              <br />
              with the right investment
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center md:flex-row md:justify-center gap-6 md:gap-3 relative top-[-15rem] w-[70vw] md:justify-self-center">
          {choices.map((choice) => (
            <HomePageCard
              key={choice.id}
              Logo={choice.icon}
              textBody={choice.textBody}
              title={choice.title}
            />
          ))}
        </div>
      </div>
	 <div className = "relative md:mt-[-20%] mt-[-55%]">
      <YearsOfExperience/>
      <CryptoTicker />
      <InvestmentPlan />
      <HowToGetStarted />
      <DashboardOnHomePage />
      <Rating />
		<News />
      <Features />
		<div className = "flex    justify-center">
		  <Button className = "font-bold w-[45%] md:w-[20%] md:mt-[3%] mt-[16%]" size = "lg" variant="ghost" color ="primary" as = "a" href = "/signup"> invest </Button>
		</div>
      <Questions />
      <Footer />
    </div>
   </div>
  );
};
export default HomPage;

